import Sidebar from "./Sidebar";
import './dashboard.css';
import React, { useState } from "react";
import Modal from "./Modal";
import APIDashboard from "./api_dashboard";
import AdminDashboard from "./admin_dashboard";
import { useLocation } from "react-router-dom";




const Dashboard = () => {
  const location = useLocation();
  const isAdmin = location.state?.isAdmin || false;
  const email = location.state.email;
  // Safely extract initials string
  const initials = location.state.initials;;
  

  return (
    <div className="dashboard-overall-container">
    {isAdmin?
      <AdminDashboard initials={initials}></AdminDashboard>
      :<APIDashboard initials={initials} passedEmail={email}></APIDashboard>}
      </div>
  );
};

export default Dashboard;